import React, { useMemo, useState } from "react";
import { ListProductUseCase } from "../../../Usecase/Products/list-product-usecase";
import { useToast } from "../../../Hooks/ToasContext";
import { IProductEntity } from "../../../Services/api/products/products.interface";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Box, Button, Typography } from '@mui/material'
import { ListCollaboratorsUseCase } from "../../../Usecase/Collaborators/list-collaborators-usecase";
import { ICollaboratorEntity } from "../../../Services/api/collaborators/collaborators.interface";
import { DestroyCollaboratorsUseCase } from "../../../Usecase/Collaborators/destroy-collaborators-usecase";
import { useNavigate } from "react-router-dom";


interface IuseListCollaboratorsProps {
  listCollaboratorsUseCase: ListCollaboratorsUseCase
  destroyCollaboratorsUseCase: DestroyCollaboratorsUseCase
}
export function useListCollaborators({ listCollaboratorsUseCase, destroyCollaboratorsUseCase }: IuseListCollaboratorsProps){
    const [loading, setLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<ICollaboratorEntity[]>([])
    const [totalRegisters, setTotalRegisters] = useState(0)
    const [collaboratorToDestroy, setCollaboratorToDestroy] = useState('')
    const navigate = useNavigate()
    const { showToast } =  useToast()

    const listCollaborators = async ({ page: currentPage, search }: any) => {
        
        try {
          setLoading(true)
          
          const listResult = await listCollaboratorsUseCase.handle({ page: currentPage, searchBy: search});

          if (listResult.isFailure) {
       
            showToast(String(listResult?.error?.error), 'error');
            return;
          }

         const list = listResult.getValue()

         if(list){
            setData(list.data)
            setTotalRegisters(list.total)
         }

         setPage(currentPage)
        } catch (error) {
          console.log("error listCollaborators function: ", error)
        } finally {
          setLoading(false);
        }
      };
    

    const handleDestroyCollaborator = async () => {
      
      try {
        setLoading(true)
        
        const listResult = await destroyCollaboratorsUseCase.handle(collaboratorToDestroy);

        if (listResult.isFailure) {
      
          showToast(String(listResult?.error?.error), 'error');
          return;
        }

        showToast('Colaborador Removido', 'success')
        listCollaborators({ page: 1, search: '' })
        setCollaboratorToDestroy('')

       
      } catch (error) {
        console.log("error listCollaborators function: ", error)
      } finally {
        setLoading(false);
      }
    };

    

    const list = useMemo(() => {
        const rows = data?.map(product => {

            return {
                ...product
            }
        })

        return rows
    }, [data])

      

    return {
        loading,
        listCollaborators,
        list,
         data,
        collaboratorToDestroy,
        setCollaboratorToDestroy,
        handleDestroyCollaborator,
        totalRegisters
        
    }
}